import LeftVideoComponent from './LeftVideo/LeftVideo'
import RightFormComponent from './RightForm/RightForm'

export const LeftVideo = LeftVideoComponent
export const RightForm = RightFormComponent

